import { render, staticRenderFns } from "./PageLayoutPicker.vue?vue&type=template&id=35ff7a24&scoped=true&"
import script from "./PageLayoutPicker.vue?vue&type=script&lang=js&"
export * from "./PageLayoutPicker.vue?vue&type=script&lang=js&"
import style0 from "./PageLayoutPicker.vue?vue&type=style&index=0&id=35ff7a24&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ff7a24",
  null
  
)

export default component.exports